export default __webpack_public_path__ + "static/media/support.e1ff782e.svg";